<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-2 pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./documents-pending-approval" routerLinkActive="active" class="nav-link" href="#">
      Documents Pending Approval
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().documents_pending_staff_approval > 0)">
        ({{ inboxService.getInboxCounts().documents_pending_staff_approval }})
      </span>
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./linking-account-requests" routerLinkActive="active" class="nav-link" href="#">
      Linking Account Requests
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().linked_account_requests > 0)">
        ({{ inboxService.getInboxCounts().linked_account_requests }})
      </span>
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./invalid-documents" routerLinkActive="active" class="nav-link" href="#">
      Invalid Documents
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().invalid_documents > 0)">
        ({{ inboxService.getInboxCounts().invalid_documents }})
      </span>
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./potential-duplicate-customers" routerLinkActive="active" class="nav-link" href="#">
      Potential Duplicate Customers
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().potential_duplicate_customers > 0)">
        ({{ inboxService.getInboxCounts().potential_duplicate_customers }})
      </span>
    </a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
